
import advancePaymentMoneyBagImage from "~/assets/images/money-bag.svg";
import AdvancePaymentSetup from "./advance-payment-setup.vue";
import AdvancePaymentBankingInfo from "./advance-payment-banking-info.vue";
import AdvancePaymentConfirmation from "./advance-payment-confirmation.vue";
export default {
  components: {
    AdvancePaymentSetup,
    AdvancePaymentBankingInfo,
    AdvancePaymentConfirmation
  },
  data() {
    return {
      advancePaymentMoneyBagImage,
      showAdvancePaymentDialog: false,
      showBankingInfoDialog: false,
      showConfirmationDialog: false,
      bankingInfo: {}
    };
  },
  methods: {
    toggleAdvancePaymentDialog(value) {
      this.showAdvancePaymentDialog = value;
    },
    toggleBankingInfoDialog(value) {
      this.showBankingInfoDialog = value;
    },
    toggleConfirmationDialog(value) {
      this.showConfirmationDialog = value;
    },
    showNextStep(data) {
      switch (data.nextStep) {
        case "BANKING_INFO":
          this.toggleAdvancePaymentDialog(false);
          this.toggleBankingInfoDialog(true);
          break;
        case "ACCOUNT_ADDED":
          this.toggleBankingInfoDialog(false);
          this.toggleConfirmationDialog(true);
          this.bankingInfo = data.formData;
          break;
      }
    }
  }
};
